import {config, request} from 'Utils';

// 列表
export function fetchList(param) {
    return request(`${config.server}/api/v2/DmsResearch/list`, {
        method: 'post',
        body: param
    });
}

// 新增
export function addSurvey(param) {
    return request(`${config.server}/api/v2/DmsResearch/insert`, {
        method: 'post',
        body: param
    });
}

// 详情
export function detail(param) {
    return request(`${config.server}/api/v2/DmsResearch/detail`, {
        method: 'post',
        body: param
    });
}

// 提交
export function submit(param) {
    return request(`${config.server}/api/v2/DmsResearch/submit`, {
        method: 'post',
        body: param
    });
}

// 取问卷所有题目的序号及用户所选答案
export function fetchQuestionSort(param) {
    return request(`${config.server}/api/v2/DmsResearch/getQuestionSort`, {
        method: 'post',
        body: param
    });
}

// 导出
export function exportString(param) {
    return `${config.server}/api/v2/DmsResearch/exportResearch?businessId=${param.businessId}`;
}

export function submitFeedback(param) {
    return request(`${config.server}/api/v2/DmsResearch/submitFeedback`, {
        method: 'post',
        body: param
    });
}


export function feedBacklist(param) {
    return request(`${config.server}/api/v2/DmsResearch/feedBacklist`, {
        method: 'post',
        body: param
    });
}

export function updateFeedback(param) {
    return request(`${config.server}/api/v2/DmsResearch/updateFeedback`, {
        method: 'post',
        body: param
    });
}



// WEBPACK FOOTER //
// ./src/service/survey/index.js